if (!customElements.get("counter-element")) {
	customElements.define(
		"counter-element",
		class CounterElement extends HTMLElement {
			constructor() {
				super();

				this.count = +this.dataset.count;
				this.counter = this.querySelector(".count");
			}

			connectedCallback() {
				this.counter.textContent = 0;
				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							this.animateCounter();
							observer.unobserve(this);
						}
					});
				});
				observer.observe(this);
			}

			animateCounter() {
				const duration = 2000;
				const startTime = performance.now();
				const easeOutQuad = (t) => t * (2 - t);

				const step = (currentTime) => {
					const elapsed = currentTime - startTime;
					let progress = Math.min(elapsed / duration, 1);
					const easedProgress = easeOutQuad(progress);
					const currentCount = Math.floor(easedProgress * this.count);
					this.counter.textContent = currentCount;

					if (progress < 1) {
						requestAnimationFrame(step);
					} else {
						this.counter.textContent = this.count;
					}
				};

				requestAnimationFrame(step);
			}
		}
	);
}
